"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadType = void 0;
var UploadType;
(function (UploadType) {
    // user avatar(that will be physically removed)
    UploadType[UploadType["UserAvatar"] = 0] = "UserAvatar";
    // space logo(that will be physically removed)
    UploadType[UploadType["SpaceLogo"] = 1] = "SpaceLogo";
    // datasheet attachment
    UploadType[UploadType["DstAttachment"] = 2] = "DstAttachment";
    // fold showcase with this
    UploadType[UploadType["CoverImage"] = 3] = "CoverImage";
    // node description
    UploadType[UploadType["NodeDesc"] = 4] = "NodeDesc";
})(UploadType = exports.UploadType || (exports.UploadType = {}));
